@if (call) {
  <div class="call-screen" [class.has-video]="showRemoteVideo" role="dialog" aria-modal="true"
    [attr.aria-label]="'call.withPeer' | t: { pseudo: name(call.peer) }">

    @if (call.video) {
      <video class="call-remote-video" [class.hidden]="!showRemoteVideo" [srcObject]="call.remoteStream" autoplay playsinline></video>
    } @else {
      <audio [srcObject]="call.remoteStream" autoplay></audio>
    }

    <div class="call-info">
      @if (!showRemoteVideo) {
        <img class="call-avatar" [class.ringing]="call.status === 'incoming' || call.status === 'outgoing'"
          [src]="avatar" alt="" width="112" height="112" />
      }
      <span class="call-pseudo">{{ name(call.peer) }}</span>
      <span class="call-status" aria-live="polite">{{ statusText }}</span>
    </div>

    @if (call.video && call.localStream) {
      <video class="call-local-video" [class.off]="call.cameraOff" [srcObject]="call.localStream" [muted]="true"
        autoplay playsinline></video>
    }

    <div class="call-controls">
      @if (call.status === 'incoming') {
        <button type="button" class="call-btn call-btn-danger" (click)="decline()" [attr.aria-label]="'call.decline' | t">
          <mat-icon>call_end</mat-icon>
        </button>
        <button type="button" class="call-btn call-btn-accept" (click)="accept()" [attr.aria-label]="'call.accept' | t">
          <mat-icon>{{ call.video ? 'videocam' : 'call' }}</mat-icon>
        </button>
      } @else {
        <button type="button" class="call-btn" [class.active]="call.muted" (click)="toggleMute()" [disabled]="!call.localStream"
          [attr.aria-label]="(call.muted ? 'call.unmute' : 'call.mute') | t" [attr.aria-pressed]="call.muted">
          <mat-icon>{{ call.muted ? 'mic_off' : 'mic' }}</mat-icon>
        </button>
        @if (call.video) {
          <button type="button" class="call-btn" [class.active]="call.cameraOff" (click)="toggleCamera()" [disabled]="!call.localStream"
            [attr.aria-label]="(call.cameraOff ? 'call.cameraOn' : 'call.cameraOff') | t" [attr.aria-pressed]="call.cameraOff">
            <mat-icon>{{ call.cameraOff ? 'videocam_off' : 'videocam' }}</mat-icon>
          </button>
        }
        <button type="button" class="call-btn call-btn-danger" (click)="hangUp()" [attr.aria-label]="'call.hangUp' | t">
          <mat-icon>call_end</mat-icon>
        </button>
      }
    </div>
  </div>
}
